//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import forumApi from '~/utils/forumApi'
import compileCloudfrontImageUrls from '~/mixins/compileCloudfrontImageUrls.js'

export default {
  mixins: [compileCloudfrontImageUrls],

  props: {
    type: {
      type: String,
      default: 'user',
    },
    avatar: {
      type: Object,
      default() {},
    },
    id: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    subline: {
      type: String,
      default: '',
    },
    shortDescription: {
      type: String,
      default: '',
    },
    whatsappNumber: {
      type: String,
      default: '',
    },
    videoLink: {
      type: String,
      default: '',
    },
    avatarForVideo: {
      type: String,
      default: '',
    },
    videoThumbnail: {
      type: Object,
      default() {},
    },
    location: {
      type: Object,
      default() {},
    },
    languages: {
      type: [String, Array],
      default() {},
    },
    implantType: {
      type: Array,
      default() {},
    },
    stats: {
      type: Array,
      default() {},
    },
    forumId: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    urlMessageTo() {
      const parameter = new URLSearchParams({ to: this.forumId })
      return `${process.env.FORUM_URL}${forumApi.MESSENGER}${
        forumApi.COMPONSE
      }?${parameter.toString()}`
    },

    sublineComputed() {
      const subline = this.subline
        ? this.$translation(`implantType.${this.subline}`)
        : ''
      return subline
    },
    translatedLanguages() {
      return Array.isArray(this.languages)
        ? this.languages?.map((lang) => this.$translation(`languages.${lang}`))
        : this.$translation(`languages.${this.languages}`)
    },
    linkWhatsapp() {
      return `https://api.whatsapp.com/send?phone=${this.whatsappNumber}`
    },
  },
  methods: {
    openMentorsForm() {
      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'get-in-touch-form-submission-start',
          'event-category': 'get-in-touch-form-submission',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }

      this.$store.commit('global/setDialog', {
        dialog: 'contact-mentor',
        layer: true,
        props: {
          focus: {
            type: 'mentor',
            id: this.id,
            firstName: this.firstName,
            lastName: this.lastName,
          },
        },
      })
    },
  },
}
